import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { css } from '@emotion/react'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import { selectIsRefreshingSearches } from 'selectors/app'
import { selectCurrentMailboxHasTickets } from 'selectors/mailboxes/selectCurrentMailboxHasTickets'
import { selectCurrentMailboxId } from 'selectors/mailboxes/selectCurrentMailboxId'

import TitleBar from './TitleBar'
import Search from './Search'
import FilterBar from './FilterBar'
import styles from './styles.less'

const searchStyle = () => theme => css`
  border-bottom: 1px solid ${theme.color.monochrome.medium};
`

export default function ConversationListHeader(props) {
  const {
    currentPart: { operator } = {},
    suggestions: { label } = {},
    SearchComponent = Search,
    TitleBarComponent = TitleBar,
    FilterBarComponent = FilterBar,
  } = props
  const defaultSize = operator === 'tag' ? 20 : 5
  const [
    previousLabelSuggestionSize,
    setPreviousLabelSuggestionSize,
  ] = useState(defaultSize)
  const showTopNav = useSelector(selectPrefersShowTopNav)
  const currentMailboxId = useSelector(selectCurrentMailboxId)
  const currentMailboxHasTickets = useSelector(selectCurrentMailboxHasTickets)
  const isRefreshingSearches = useSelector(selectIsRefreshingSearches)

  const showActionBar =
    currentMailboxHasTickets === true ||
    !currentMailboxId ||
    isRefreshingSearches

  useEffect(
    () => {
      const previousLabelSuggestions = label
      const first = previousLabelSuggestions && previousLabelSuggestions[0]
      if (previousLabelSuggestions && (!first || !first.isLoading)) {
        const newSizeSuggestion = previousLabelSuggestions.length || defaultSize
        setPreviousLabelSuggestionSize(newSizeSuggestion)
      }
    },
    [label, defaultSize, setPreviousLabelSuggestionSize]
  )

  return (
    <div
      className={cn(
        styles['conversation-list-header'],
        'conversation-list-header'
      )}
    >
      {SearchComponent &&
        !showTopNav && (
          <SearchComponent
            css={searchStyle}
            previousLabelSuggestionSize={previousLabelSuggestionSize}
          />
        )}
      {showActionBar && (
        <>
          <TitleBarComponent />
          <FilterBarComponent />
        </>
      )}
    </div>
  )
}
